import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Field,  } from 'redux-form';
import renderFileInputField from '../../../../../../shared/components/form/FileInput';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintIcon from '@material-ui/icons/Print';
import pdfMake from 'pdfmake/build/pdfmake.js';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class EKG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],      
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      professional: "",
      ritmo: "",
      fc: "",
      ondaP: "",
      pr: "",
      qr_s: "",
      eje_qrs: "",
      styt: "",
      qtc: "",
      conclusions: "",
      diagnostico: "",
      descripcion_d: "",
      urlLogo: 'https://i.postimg.cc/WpG6Rg5q/logo-SAC-App-New.png',
      dataPatient: [],
      age: '',
      date: new Date(),
      birthday: null,
      today: new Date(),
      day: new Date(),
      profile: sessionStorage.getItem('perfil'),
    }
  }

  componentDidMount() {
    this.getData();
    this.setState({ addedDiagnostics: this.props.addedMedicaments })
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional !== null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty, professional: this.props.professional, loadProfessionals: false }, () => {
              //this.props.handlerMedicalProcedures("EKG", "professional", this.props.professional);
            });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      stress: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        ao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        adult: "",
        description: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: "",
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        ritmo: this.state.ritmo,
        fc: this.state.fc,
        ondaP: this.state.ondaP,
        pr: this.state.pr,
        qr_s: this.state.qr_s,
        eje_qrs: this.state.eje_qrs,
        styt: this.state.styt,
        qtc: this.state.qtc,
        conclusions: this.state.conclusions,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: "",
        conclusion: "",
        diagnostico: "",
        descripcion_d: ""
      },
    }

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL +'/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataPatient = () => {
    var data = { num_documento: this.props.num_documento };

    fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.existe) {
          console.log(data.contenido[0]);
          this.setState({ dataPatient: data.contenido[0] });
          this.calculateAge(data.contenido[0].fec_nacimiento);
        }

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  calculateAge = (birthday) => {
    let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
    let nacimiento = moment(birthday).format("YYYY-MM-DD");
    let hoy = new Date();
    this.setState({ age: fecha, birthday: nacimiento, today: moment(hoy).format('LLL'), day: moment(hoy).format('LL') });
    this.PrintProcedurePDF();
  }

  PrintProcedurePDF = async () => {

    const fecha = this.state.today;
    const name = this.state.dataPatient.tip_documento + '-' + this.state.dataPatient.num_documento + ' ' + this.state.dataPatient.nombres + ' ' + this.state.dataPatient.apellido1 + ' ' + this.state.dataPatient.apellido2;

    const header = {
      image: await this.getBase64ImageFromURL(this.state.urlLogo),
      width: 80,
      height: 30,
      alignment: 'center',
      margin: [ 0, 10, 0, 20 ]
    }


    const documentDefinition = {
      pageSize: 'LETTER',
      pageOrientation: 'portrait',
      header: header,
      footer: function (currentPage, pageCount) {

        return {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [{ text: "Pagina " + currentPage.toString() + ' de ' + pageCount, style: 'head' }, { text: name, style: 'head' }, { text:'Fecha Impresion: ' + fecha, style: 'head' }],
            ]
          },
          layout: 'noBorders',
          margin: [20, 0, 0, 5],
        };
      },
      content: [
        {
          text: 'ELECTROCARDIOGRAMA', style: 'title' , margin: 15
        },
        {
          text: 'Lugar y fecha, Santiago de cali ' + fecha, style: 'textStyle' 
        },
        {
          // auto-sized columns have their widths based on their content                                       
          margin: [0, 5, 0, 10],                   
          table: {            
            widths: ['*', '*', '*', '*'],
            body: [                           
              [{ text: 'Nombre del Paciente', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.nombres + ' ' + this.state.dataPatient.apellido1 + ' ' + this.state.dataPatient.apellido2, style: 'textStyle' },{ text: 'Documento de Identificacions', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.tip_documento + '-' + this.state.dataPatient.num_documento , style: 'textStyle' }],
              [{ text: 'Edad ', bold: true, style: 'textStyle' }, { text: this.state.age, style: 'textStyle' }, { text: 'Genero ', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.sexo, style: 'textStyle' }],
              [{ text: 'Historia Clinilca ', bold: true, style: 'textStyle' }, { text: this.state.dataPatient.id_historia, style: 'textStyle' }, { text: 'Tipo de Usuario ', bold: true, style: 'textStyle' }, ''],
              [{ text: 'Diagnostico ', bold: true, style: 'textStyle' }, '','',''],
            ]
          },
        },              
        {
          margin: [140, 10, 0, 10],
          table: {
              widths: [80, 160],
              headerRows: 1,
              body: [
                [{ text: 'Ritmo', bold: true, style: 'textStyle'}, { text: this.state.ritmo === "" ? "-" : this.state.ritmo, style: 'textStyle'}],
                [{ text: 'FC', bold: true, style: 'textStyle'}, { text: this.state.fc === "" ? "-" : this.state.fc, style: 'textStyle'}],
                [{ text: 'Onda P', bold: true, style: 'textStyle'}, { text: this.state.ondaP === "" ? "-" : this.state.ondaP, style: 'textStyle'}],
                [{ text: 'PR', bold: true, style: 'textStyle'}, { text: this.state.pr === "" ? "-" : this.state.pr, style: 'textStyle'}],
                [{ text: 'QRS', bold: true, style: 'textStyle'}, { text: this.state.qr_s === "" ? "-" : this.state.ondaP, style: 'textStyle'}],
                [{ text: 'EJE QRS', bold: true, style: 'textStyle'}, { text: this.state.eje_qrs === "" ? "-" : this.state.eje_qrs, style: 'textStyle'}],
                [{ text: 'EJE QRS', bold: true, style: 'textStyle'}, { text: this.state.eje_qrs === "" ? "-" : this.state.eje_qrs, style: 'textStyle'}],
                [{ text: 'ST y T', bold: true, style: 'textStyle'}, { text: this.state.styt === "" ? "-" : this.state.styt, style: 'textStyle'}],
                [{ text: 'QTC', bold: true, style: 'textStyle'}, { text: this.state.qtc === "" ? "-" : this.state.qtc, style: 'textStyle'}],
              ]
          },
      },
        {
          text: 'CONCLUSIÓN', style: 'title' 
        },
        {
          text: this.state.conclusions === "" ? "" : this.state.conclusions , style: 'textStyle' 
        },
        {
          text: '\n\n\n\n\n\n\n\n UNIDAD DE ESPECILISTAS MEDICAS S.A.S \n Calle 9C No. 50-25 Clinica farallones Telefonos: 5133729 - 5133783 \n', style: 'tableTexStyle' 
        },
      ],
      styles: {
        head: {
          fontSize: 7,
          bold: true,
          alignment: 'left'
        },
        title: {
          fontSize: 10,
          bold: true,
          alignment: 'center',

        },
        textStyle: {
          fontSize: 9,
        },
        tableTexStyle: {
          fontSize: 8,
          alignment: 'center'
        },
        foter: {
          alignment: 'center',
          fontSize: 6,
        },        
      }
    };

    pdfMake.createPdf(documentDefinition).open();

  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  }

  handlerRitmo = (ritmo) => {
    this.setState({ ritmo: ritmo });
  }

  handlerFc = (fc) => {
    this.setState({ fc: fc });
  }

  handlerOndaP = (ondaP) => {
    this.setState({ ondaP: ondaP });
  }

  handlerPr = (pr) =>{
    this.setState({pr : pr});
  }

  handlerQrs = (qrs) => {
    this.setState({ qrs: qrs });
  }

  handlerEjeQrs = (ejeQrs) => {
    this.setState({ ejeQrs: ejeQrs });
  }

  handlerStyt = (styt) => {
    this.setState({ styt: styt });
  }

  handlerQtc = (qtc) => {
    this.setState({ qtc: qtc });
  }

  handlerConclusion = (conclusion) => {
    this.setState({ conclusions: conclusion })
  }

  render() {    

    return (<Col>
      <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
        <div className="card__title">
          <h5 className="bold-text">EKG</h5>
        </div>
        
          <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
            <TextField
              required
              disabled
              id="specilaity-standard-required"
              label="Especialidad"
              type="text"
              value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad }
              onChange={(e) => {
                this.handlerSpeciality(e.target.value);
              }}
            />
            <TextField
              required
              disabled
              id="professional-standard-required"
              label="Profesional"
              type="text"
              value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
              onChange={(e) => {
                this.handlerProfessional(e.target.value);
              }}
            />
          </div>
        
      </div>
      <div className="form">
        <table className="table " style={{ marginTop: 20 }} >
          <tbody>
            <tr>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>RITMO</span>
                  <div className="form__form-group-field">
                    <Field
                      name="RITMO-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "ritmo", e.target.value);
                        
                          this.handlerRitmo(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>FC</span>
                  <div className="form__form-group-field">
                    <Field
                      name="FC-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                       
                          this.props.handlerMedicalProcedures("EKG", "fc", e.target.value);
                        
                          this.handlerFc(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>ONDA P</span>
                  <div className="form__form-group-field">
                    <Field
                      name="ONDA-P-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                       
                          this.props.handlerMedicalProcedures("EKG", "ondaP", e.target.value);
                        
                          this.handlerOndaP(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>PR</span>
                  <div className="form__form-group-field">
                    <Field
                      name="PR-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "pr", e.target.value);
                        
                          this.handlerPr(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>QRS</span>
                  <div className="form__form-group-field">
                    <Field
                      name="QRS-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "qrs", e.target.value);
                        
                          this.handlerQrs(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>EJE QRS</span>
                  <div className="form__form-group-field">
                    <Field
                      name="EJE-QRS-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "ejeQRS", e.target.value);
                        
                          this.handlerEjeQrs(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>ST Y T</span>
                  <div className="form__form-group-field">
                    <Field
                      name="ST-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "styt", e.target.value);
                        
                          this.handlerStyt(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                  <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>QTc</span>
                  <div className="form__form-group-field">
                    <Field
                      name="QTc-EKG"
                      component="input"
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        
                          this.props.handlerMedicalProcedures("EKG", "qtc", e.target.value);
                        
                          this.handlerQtc(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="form__form-group">
          <span className="form__form-group-label">Conclusión</span>
          <div className="form__form-group-field">
          <textarea
              name="textarea-conclusion-EKG" rows="10" cols="50"
              defaultValue={this.props.dataProcedure.conclusions}
              onChange={(e) => {

                this.props.handlerMedicalProcedures("EKG", "conclusion", e.target.value);
                this.handlerConclusion(e.target.value);

              }}>

            </textarea>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            Agregar archivo
          </span>
          <div className="form__form-group-field">
            <Field
              name="file-EKG"
              component={renderFileInputField}
              onChange={(e) => {
                this.props.handlerMedicalProcedures("EKG", "file", e);
              }}
            />
          </div>
        </div>
      </div>           
      
      {this.state.profile === "12" || this.state.profile === "4" ?
        (<Button
          style={{ marginTop: 20 }}
          variant="contained"
          color="primary"
          onClick={() => {
            this.saveProcedure();
          }}
        > Guardar Procedimieto
        </Button>) : null
      }

      <Button
        style={{ marginTop: 20, marginLeft: 20 }}
        variant="contained"
        color="primary"
        startIcon={<PrintIcon />}
        onClick={() => {
          this.loadDataPatient();
        }}
      > Imprimir
      </Button>

    </Col>)

  }
}

export default EKG;